export default {
	moreLabel: "show more",
	fewerLabel: "show fewer",
};
